import { Navigate, NavLink, useLocation, useParams } from 'react-router-dom'
import { ReactComponent as DailyReportsIcon } from 'BoostXpressAdmin/Assets/Icon/Sidebar/daily-reports.svg'
import { ReactComponent as ReconciliationIcon } from 'BoostXpressAdmin/Assets/Icon/Sidebar/reconciliation.svg'
import { ReactComponent as StockDeliveryIcon } from 'BoostXpressAdmin/Assets/Icon/Sidebar/stock-delivery.svg'
import { ReactComponent as PriceChangeIcon } from 'BoostXpressAdmin/Assets/Icon/Sidebar/price-change.svg'
import { useAuth } from 'Components/AuthProvider/AuthProvider'
import AdminWrapper from 'BoostXpressAdmin/Pages/Skeleton/AdminWrapper/AdminWrapper'
import logo from 'Assets/Images/logo-white.svg'
import './StationOperations.scss'

const sections = [
  { path: 'daily-reports', label: 'Daily Reports', Icon: DailyReportsIcon },
  { path: 'reconciliation', label: 'Reconciliation', Icon: ReconciliationIcon },
  { path: 'stock-delivery', label: 'Stock Delivery', Icon: StockDeliveryIcon },
  { path: 'price-change', label: 'Price Change', Icon: PriceChangeIcon },
]

const StationOperations = () => {
  const { isLocalAuth } = useAuth()
  if (!isLocalAuth) return <Navigate to='/login' replace />

  return (
    <AdminWrapper
      title='Station Operations'
      brandLogo={logo}
      brandName='Station Operations'
      sidebarContent={
        <div className='bx-sidebar__section station-operations-navigation'>
          <div className='bx-sidebar__section-title'>Station Operations</div>
          {sections.map(({ path, label, Icon }) => (
            <NavLink
              key={path}
              to={`/station-operations/${path}`}
              className={({ isActive }) =>
                `bx-sidebar__item${isActive ? ' bx-sidebar__item--active' : ''}`
              }
            >
              <Icon className='bx-sidebar__item-icon' aria-hidden='true' focusable='false' />
              <span className='bx-sidebar__item-label'>{label}</span>
            </NavLink>
          ))}
        </div>
      }
    />
  )
}

// Preserve bookmarked report links and any station/manager navigation context.
export const LegacyStationReportRedirect = () => {
  const { id } = useParams<{ id: string }>()
  const location = useLocation()
  return <Navigate to={`/station-operations/daily-reports/${id}`} replace state={location.state} />
}

export default StationOperations
